import { Controller } from "remult";

@Controller("call-center-tour-step-methods")
export class CallCenterTourStepMethods {}
